import { render } from "./InicioUsuarios.vue?vue&type=template&id=6867e59a&scoped=true"
import script from "./InicioUsuarios.vue?vue&type=script&lang=js"
export * from "./InicioUsuarios.vue?vue&type=script&lang=js"

import "./InicioUsuarios.vue?vue&type=style&index=0&id=6867e59a&lang=scss&scoped=true"

import exportComponent from "/Users/coolio/Documents/proyectos/karga/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6867e59a"]])

export default __exports__